import React from 'react';

import { formatDate } from 'Helpers/dateUtils';
import { formatFigure } from 'Helpers/formatService';

import Modal from 'CommonComponents/Modal';

const ActualVsBudgetReportTransactionsModal = (props) => {
    return (
        <Modal id={props.id} modal={props.modal} innerContainerClasses="tw-bg-[#F8F8F8]" containerStyle={{ minWidth: '1280px', maxWidth: '1800px' }}>
            <div className="inbud-table_wrapper tw-overflow-y-auto tw-max-h-[374px]">
                <table className="inbud-table inbud-table_first-sticky">
                    <thead className="tw-sticky tw-top-0 tw-z-10">
                        <tr>
                            <th>{$t('Description')}</th>
                            <th className="tw-w-80">{$t('Supplier')}</th>
                            <th className="tw-w-44">{$t('Contract Reference')}</th>
                            <th className="tw-w-28">{$t('Date')}</th>
                            <th className="tw-w-36">{$t('Net Amount')}</th>
                            <th className="tw-w-16">{$t('Type')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.transactions?.length === 0 ? (
                            <tr>
                                <td colSpan="6" className="tw-text-center tw-py-4">
                                    {$t('No transactions found')}
                                </td>
                            </tr>
                        ) : (
                            props.transactions.map((transaction, index) => (
                                <tr key={index}>
                                    <td>{transaction.transaction_description || ''}</td>
                                    <td>{transaction.supplier || ''}</td>
                                    <td>{transaction.contract_reference || ''}</td>
                                    <td className="inbud-date-cell tw-text-center">{formatDate(transaction.date)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(transaction.amount)}</td>
                                    <td className="tw-text-center">{transaction.transaction_type ?? '-'}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </Modal>
    );
};

export default ActualVsBudgetReportTransactionsModal;
